<div class="sidebar-spacer d-none d-lg-block"></div>
<nav class="workout-sidebar">
  <div class="sidebar-title">Workout Tracker</div>
  <ul class="sidebar-nav">
    <li *ngFor="let tab of tabs"
        [class.active]="activeTab === tab.key"
        (click)="onTabClick(tab.key)">
      <span class="sidebar-icon">{{ tab.icon }}</span> {{ tab.label }}
    </li>
  </ul>
</nav>

